import {HttpService} from "src/modules/common/http/service/HttpService";
import {
    PagedResponse,
    ReceiptLogListItem,
    ReceiptLogDetail,
    ReceiptLogQueryParams
} from "../model/AdminDashboardTypes";

export class AdminDashboardService {
    private static readonly RECEIPT_LOGS_URL = "/internal/api/receipt-logs";

    constructor(private readonly httpService: HttpService) {}

    getReceiptLogs = (params: ReceiptLogQueryParams): Promise<PagedResponse<ReceiptLogListItem>> => {
        const query = new URLSearchParams();
        query.set("page", String(params.page));
        query.set("size", String(params.size));
        query.set("sort", params.sort);
        if (params.sortField) query.set("sortField", params.sortField);
        if (params.loanNumber) query.set("loanNumber", params.loanNumber);
        if (params.transactionStatus) query.set("transactionStatus", params.transactionStatus);
        if (params.paymentIntentId) query.set("paymentIntentId", params.paymentIntentId);
        if (params.chargeId) query.set("chargeId", params.chargeId);
        if (params.since) query.set("since", params.since);
        if (params.until) query.set("until", params.until);
        if (params.brandSlug) query.set("brandSlug", params.brandSlug);
        const url = `${AdminDashboardService.RECEIPT_LOGS_URL}?${query.toString()}`;
        return this.httpService.fetchAs<PagedResponse<ReceiptLogListItem>>({url});
    };

    getReceiptLogDetail = (id: number): Promise<ReceiptLogDetail> => {
        return this.httpService.fetchAs<ReceiptLogDetail>({
            url: `${AdminDashboardService.RECEIPT_LOGS_URL}/${id}`
        });
    };
}
